export const Footer = (props) => {
  // Determine the correct privacy policy link based on language
  const privacyPolicyUrl = props.currentLanguage === 'et' 
    ? '/privacy-policy?lang=et' 
    : '/privacy-policy?lang=en';
    
  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            {props.data ? props.data.copyright : '© 2025 RecycleMore OÜ.'}{' '}
            <a href={privacyPolicyUrl} rel='nofollow'>
              {props.data ? props.data.termsLink : 'Kasutustingimused'}
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}